import Vue from 'vue'
import API from '../../../api/endpoints'

export default {
  getToken (params) {
    return Vue.http.post(API.GET_TOKEN, params)
  },
  getRates (rateRequest) {
    return Vue.http.post(API.GET_RATES, rateRequest)
  },
  getRatesMulti (arr) {
    return Vue.http.post(API.GET_RATES_MULTI, arr)
  },
  getMaiRates (rateRequest) {
    return Vue.http.post(API.GET_MAI_RATES, rateRequest)
  },
  getAccessorials (accessorialRequest) {
    return Vue.http.post(API.GET_ACCESSORIALS, accessorialRequest)
  },
  getGraph (rateRequest) {
    return Vue.http.post(API.GET_GRAPH, rateRequest)
  },
  getParties (providersArray) {
    return Vue.http.get(API.GET_ENTITIES_IN('party'), {
      params: {
        code: JSON.stringify(providersArray)
      }
    })
  },
  getWorkbench (req) {
    return Vue.http.post(API.GET_WORKBENCH, req)
  },
  getJobTypes (json) {
    return Vue.http.get(API.GET_ENTITIES('job-type'), {
      params: json,
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getFinanceProfile (json) {
    return Vue.http.get(API.GET_ENTITIES('financial-profile'), {
      params: json,
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getFinanceItems (json) {
    return Vue.http.get(API.GET_ENTITIES('financial-profile-item'), {
      params: json,
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  getFinancialProfileItems (json) {
    return Vue.http.get(API.FINANCE_PROFILE_ITEMS, {
      params: json,
      headers: { 'X-Lazy-Fetch': '0' }
    })
  },
  saveJob (req) {
    return Vue.http.post(API.JOB, req)
  }
}



// WEBPACK FOOTER //
// ./src/modules/quote/store/service.js